// RouteZero brand. The official logo is design/brand/RouteZero-logo-option-1.png
// (the supplied artwork, already transparent: 76 % of its pixels have alpha 0).
// Served assets in public/images/brand are made from it without touching pixels:
//   routezero-logo-960.png      full logo, invisible (alpha ≤ 1) margin trimmed, scaled proportionally
//   routezero-symbol-{512,192,64}.png  the "R" route symbol cropped from the same file,
//                                      original pixels and alpha, padded to a square with transparency
// Rules: never put the artwork in a box, panel or badge; no CSS filters, shadows,
// blend modes or recolouring. The full logo's "Route" lettering and tagline are dark
// navy, so the full logo is used only on light surfaces (landing page, login card);
// the dark navy header uses the symbol plus a live-text name beside it.
import { h } from './h.js';

export const BRAND = { name: 'RouteZero', tagline: 'Start with zero. Engineer your future.' };
// The single-file build inlines these as data: URIs (scripts/build-single.mjs).
const inlined = (p) => (typeof globalThis !== 'undefined' && globalThis.__NELL_IMAGES__?.[p]) || p;
export const LOGO_SRC = 'images/brand/routezero-logo-960.png';
export const LOGO_RATIO = 960 / 668; // width / height of the served full logo
export const symbolSrc = (px = 192) => inlined(`images/brand/routezero-symbol-${px >= 256 ? 512 : px >= 96 ? 192 : 64}.png`);

/** The complete official logo (symbol + RouteZero lettering + tagline). Light surfaces only. */
export function logoFull({ width = 360, cls = '', alt = `${BRAND.name} — ${BRAND.tagline}` } = {}) {
  return h('img', {
    class: `rz-logo-full ${cls}`, src: inlined(LOGO_SRC), width, height: Math.round(width / LOGO_RATIO),
    alt, 'data-testid': 'rz-logo-full', draggable: 'false', decoding: 'async',
  });
}
/** The route "R" symbol from the official logo. Decorative when the name is shown next to it. */
export function logoMark({ size = 36, cls = '', decorative = true } = {}) {
  return h('img', {
    class: `rz-mark ${cls}`, src: symbolSrc(size * 2), width: size, height: size,
    alt: decorative ? '' : 'RouteZero', 'aria-hidden': decorative ? 'true' : null, 'data-testid': 'rz-logo', draggable: 'false',
  });
}
/** "Route" + "Zero" as live text (header only, next to the symbol — never over the artwork). */
export const wordmark = (cls = '') => h('span', { class: `rz-wordmark ${cls}` }, h('span', { class: 'rz-w-route' }, 'Route'), h('span', { class: 'rz-w-zero' }, 'Zero'));
